function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDefaultAvatarBuilding = function SvgDefaultAvatarBuilding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M26 25.5c0-1.9 1.6-3.5 3.5-3.5h20.9c1.9 0 3.5 1.6 3.5 3.5v28.9c0 1.9-1.6 3.5-3.5 3.5H44v-6.4c0-.9-.7-1.6-1.6-1.6h-4.9c-.9 0-1.6.7-1.6 1.6V58h-6.5c-1.9 0-3.5-1.6-3.5-3.5v-29zm7.8.5c-1.1 0-2 .9-2 2s.9 2 2 2h12.4c1.1 0 2-.9 2-2s-.9-2-2-2H33.8zm-2 10c0-1.1.9-2 2-2h12.4c1.1 0 2 .9 2 2s-.9 2-2 2H33.8c-1.1 0-2-.9-2-2zm2 6c-1.1 0-2 .9-2 2s.9 2 2 2h12.4c1.1 0 2-.9 2-2s-.9-2-2-2H33.8z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgDefaultAvatarBuilding;